// import React from "react";
// import { Treemap, ResponsiveContainer } from "recharts";
// import { useTopVolumeGainers } from "../../../hooks";
// import { Box, Skeleton, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { useBitcoinPrice } from '../../../state/context/bitcoin.context'; // Adjust path if needed

// const truncateText = (text = "", maxWidth) => {
//   if (!text) return "";
//   const maxChars = Math.floor(maxWidth / 8); // Approximate character width
//   return text.length > maxChars ? text.substring(0, maxChars) + "..." : text;
// };

// function transformToBTC(value) {
//   const sats = value / 1000;
//   const btc = sats / 100000000;
//   return btc;
// }
// const CustomTreemap = ({ selectedTimeOffset }) => {
//   const { data, loading, error } = useTopVolumeGainers(selectedTimeOffset, 10);
//   const navigate = useNavigate();
//   const { price: btcPrice } = useBitcoinPrice(); // Renamed for clarity to avoid conflict if needed elsewhere


//   if (loading)
//     return (
//       <Skeleton
//         variant="rectangular"
//         width={"100%"}
//         // sx={{ bgcolor: "grey.900" }}
//         height={300}
//       />
//     );
//   if (error)
//     return (
//       <Typography color="error" align="center">
//         Error: {error?.message}
//       </Typography>
//     );

//   return (
//     <ResponsiveContainer width="100%" height={"100%"}>
//       <Treemap
//         width={730}
//         height={250}
//         data={data.map((item) => ({
//           name: item?.token?.name || "N/A",
//           size: item?.totalBuyVolume || 0,
//           id: item?.token?.id,
//         }))}
//         dataKey="size"
//         aspectRatio={4 / 3}
//         stroke="#fff"
//         fill="#3498db"
//         content={({ x, y, width, height, name = "", size = 0, id }) => {
//           if (!name) return null;

//           const maxFontSize = 16;
//           const fontSize = Math.min(
//             width / (name.length || 1),
//             height / 2.5,
//             maxFontSize
//           );
//           const truncatedName = truncateText(name, width - 10);
//           const valueFontSize = fontSize * 0.8; // Slightly smaller font for value

//           return (
//             <g onClick={() => {
//               // window.open(`https://odin.fun/token/${id}`,"_blank")
//                window.open(`/tokens/${ id }`);
//             }}
//               style={{ cursor: "pointer" }}

//             >
//               <rect
//                 x={x}
//                 y={y}
//                 width={width}
//                 height={height}
//                 fill="#3498db"
//                 stroke="#fff"
//               />
//               {width > 30 &&
//                 height > 40 && ( // Ensure enough space
//                   <>
//                     {/* Token Name */}
//                     <text
//                       x={x + width / 2}
//                       y={y + height / 2 - 5} // Position slightly above center
//                       textAnchor="middle"
//                       fill="#fff"
//                       fontSize={fontSize}
//                       fontWeight="bold"
//                       dy=".35em"
//                     >
//                       {truncatedName}
//                     </text>

//                     {/* Token Value */}
//                     <text
//                       x={x + width / 2}
//                       y={y + height / 2 + 12} // Position below name
//                       textAnchor="middle"
//                       fill="#fff"
//                       fontSize={valueFontSize}
//                       fontWeight="normal"
//                       dy=".35em"
//                     >
//                       {transformToBTC(size).toFixed(3)} BTC
//                     </text>
//                     {
//                       btcPrice && (
//                         <text
//                           x={x + width / 2}
//                           y={y + height / 2 + 30} // Position below value
//                           textAnchor="middle"
//                           fill="rgba(255, 255, 255, 0.5)"
//                           fontSize={valueFontSize}
//                           fontWeight="normal"
//                           dy=".35em"
//                         >
//                           {`${ (size / 1e11 * btcPrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }`}
//                         </text>
//                       )
//                     }
//                   </>
//                 )}
//             </g>
//           );
//         }}
//       />
//     </ResponsiveContainer>
//   );
// };

// export default CustomTreemap;



import React from "react";
import { Treemap, ResponsiveContainer } from "recharts";
import { useTopVolumeGainers } from "../../../hooks";
import { Box, Skeleton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useBitcoinPrice } from '../../../state/context/bitcoin.context'; // Adjust path if needed

const truncateText = (text = "", maxWidth) => {
  if (!text) return "";
  const maxChars = Math.floor(maxWidth / 8); // Approximate character width
  return text.length > maxChars ? text.substring(0, maxChars) + "..." : text;
};

function transformToBTC(value) {
  const sats = value / 1000;
  const btc = sats / 100000000;
  return btc;
}



const data = [
  {
    name: 'Electronics',
    imgUrl: 'https://placehold.co/600x400/3498db/ffffff?text=Electronics',
    children: [
      { name: 'Phones', size: 4000, imgUrl: 'https://placehold.co/600x400/2ecc71/ffffff?text=Phones' },
      { name: 'Laptops', size: 2500, imgUrl: 'https://placehold.co/600x400/f1c40f/ffffff?text=Laptops' },
      { name: 'Tablets', size: 2000, imgUrl: 'https://placehold.co/600x400/e74c3c/ffffff?text=Tablets' },
      { name: 'Monitors', size: 1800, imgUrl: 'https://placehold.co/600x400/9b59b6/ffffff?text=Monitors' },
    ],
  },
  {
    name: 'Furniture',
    imgUrl: 'https://placehold.co/600x400/1abc9c/ffffff?text=Furniture',
    children: [
      { name: 'Chairs', size: 3000, imgUrl: 'https://placehold.co/600x400/e67e22/ffffff?text=Chairs' },
      { name: 'Tables', size: 2800, imgUrl: 'https://placehold.co/600x400/34495e/ffffff?text=Tables' },
      { name: 'Sofas', size: 4500, imgUrl: 'https://placehold.co/600x400/7f8c8d/ffffff?text=Sofas' },
    ],
  },
  {
    name: 'Clothing',
    imgUrl: 'https://placehold.co/600x400/27ae60/ffffff?text=Clothing',
    children: [
      { name: 'Shirts', size: 2200, imgUrl: 'https://placehold.co/600x400/d35400/ffffff?text=Shirts' },
      { name: 'Pants', size: 2100, imgUrl: 'https://placehold.co/600x400/c0392b/ffffff?text=Pants' },
      { name: 'Shoes', size: 1500, imgUrl: 'https://placehold.co/600x400/8e44ad/ffffff?text=Shoes' },
    ],
  },
];

// --- Custom Content Renderer ---
// This component is rendered for each node in the treemap.
// It receives props like position (x, y), size (width, height), and the data object.
const CustomizedContent = (props) => {
  const { root, depth, x, y, width, height, index, payload, rank, name, imgUrl, size, id } = props;
  const { price: btcPrice } = useBitcoinPrice(); // Renamed for clarity to avoid conflict if needed elsewhere

  // We only render the content for the leaf nodes (depth === 1)
  // and only if the node is large enough to display text.
  const isLeaf = depth === 1;
  const showText = width > 80 && height > 40;
  if (!name) return null;


  const maxFontSize = 16;
  const fontSize = Math.min(
    width / (name.length || 1),
    height / 2.5,
    maxFontSize
  );
  const truncatedName = truncateText(name, width - 10);
  const valueFontSize = fontSize * 0.8; // Slightly smaller font for value

  return (
    <g>
      {/* Rectangle with Image Background */}
      <foreignObject x={x} y={y} width={width} height={height}>
        <div
          style={{
            width: `${ width }px`,
            height: `${ height }px`,
            backgroundImage: `url(${ imgUrl })`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // borderRadius: '8px',
            overflow: 'hidden',
            position: 'relative',
            border: '.2px solid rgba(255, 255, 255, 0.6)',
            boxSizing: 'border-box'
          }}
          onClick={() => window.open(`/tokens/${id}`)}
        >
          {/* Semi-transparent overlay for better text readability */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
            }}
          />
          {/* Display the name of the node */}
          {showText && (
            <div
              style={{
                color: 'white',
                fontSize: `${ fontSize }px`,
                fontWeight: 'bold',
                textAlign: 'center',
                padding: '4px',
                position: 'relative',
                zIndex: 1,
                textShadow: '1px 1px 3px rgba(0,0,0,0.7)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div className="token-name">{name}</div>
              <div className="token-value">{transformToBTC(size).toFixed(3)} BTC</div>
              {
                btcPrice && (
                  <div className="token-value-usd"> {`${ (size / 1e11 * btcPrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }`}</div>
                )
              }
            </div>
          )}

        </div>
      </foreignObject>
    </g>
  );
};
const CustomTreemap = ({ selectedTimeOffset }) => {
  const { data, loading, error } = useTopVolumeGainers(selectedTimeOffset, 10);
  const navigate = useNavigate();


  if (loading)
    return (
      <Skeleton
        variant="rectangular"
        width={"100%"}
        // sx={{ bgcolor: "grey.900" }}
        height={300}
      />
    );
  if (error)
    return (
      <Typography color="error" align="center">
        Error: {error?.message}
      </Typography>
    );

  return (
    <ResponsiveContainer width="100%" height={"100%"}
    >
      <Treemap
        width={730}
        height={250}
        data={data.map((item) => ({
          name: item?.token?.name || "N/A",
          size: item?.totalBuyVolume || 0,
          id: item?.token?.id,
          imgUrl: `https://images.odin.fun/token/${ item?.token?.id || '2ui6' }` // Default image if ID is not available
        }))}
        dataKey="size"
        aspectRatio={4 / 3}
        stroke="#fff"
        fill="#3498db"
        style={{
          borderRadius: '10px',

        }}
        // content={({ x, y, width, height, name = "", size = 0, id }) => {
        //   if (!name) return null;

        //   const maxFontSize = 16;
        //   const fontSize = Math.min(
        //     width / (name.length || 1),
        //     height / 2.5,
        //     maxFontSize
        //   );
        //   const truncatedName = truncateText(name, width - 10);
        //   const valueFontSize = fontSize * 0.8; // Slightly smaller font for value

        //   return (
        //     <g onClick={() => {
        //       // window.open(`https://odin.fun/token/${id}`,"_blank")
        //        window.open(`/tokens/${ id }`);
        //     }}
        //       style={{ cursor: "pointer" }}

        //     >
        //       <rect
        //         x={x}
        //         y={y}
        //         width={width}
        //         height={height}
        //         fill="#3498db"
        //         stroke="#fff"
        //       />
        //       {width > 30 &&
        //         height > 40 && ( // Ensure enough space
        //           <>
        //             {/* Token Name */}
        //             <text
        //               x={x + width / 2}
        //               y={y + height / 2 - 5} // Position slightly above center
        //               textAnchor="middle"
        //               fill="#fff"
        //               fontSize={fontSize}
        //               fontWeight="bold"
        //               dy=".35em"
        //             >
        //               {truncatedName}
        //             </text>

        //             {/* Token Value */}
        //             <text
        //               x={x + width / 2}
        //               y={y + height / 2 + 12} // Position below name
        //               textAnchor="middle"
        //               fill="#fff"
        //               fontSize={valueFontSize}
        //               fontWeight="normal"
        //               dy=".35em"
        //             >
        //               {transformToBTC(size).toFixed(3)} BTC
        //             </text>
        //             {
        //               btcPrice && (
        //                 <text
        //                   x={x + width / 2}
        //                   y={y + height / 2 + 30} // Position below value
        //                   textAnchor="middle"
        //                   fill="rgba(255, 255, 255, 0.5)"
        //                   fontSize={valueFontSize}
        //                   fontWeight="normal"
        //                   dy=".35em"
        //                 >
        //                   {`${ (size / 1e11 * btcPrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }`}
        //                 </text>
        //               )
        //             }
        //           </>
        //         )}
        //     </g>
        //   );
        // }}
        content={<CustomizedContent />} // Use our custom component to render nodes

      />
    </ResponsiveContainer>
  );
};

export default CustomTreemap;
